import React from "react";

const PreviousRatingsModal = ({
  isOpen,
  onClose,
  tenantEmail,
  tenantPhone,
  ratings = [],
  loading = false,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[1000] flex items-center justify-center">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/40"
        onClick={onClose}
        aria-hidden="true"
      />
      {/* Dialog */}
      <div className="relative z-[1001] w-[92%] max-w-[640px] rounded-xl bg-white shadow-xl">
        {/* Header */}
        <div className="flex items-center justify-between px-5 py-4 border-b">
          <h3 className="text-base sm:text-lg md:text-xl font-semibold text-[#09114B]">
            Previous Ratings on Tenafix
          </h3>
          <button
            onClick={onClose}
            className="text-[#6B7280] hover:text-[#111827] text-xl leading-none"
            aria-label="Close"
          >
            ×
          </button>
        </div>

        {/* Meta */}
        <div className="px-5 pt-3 text-xs sm:text-sm text-gray-600">
          <div className="flex flex-wrap gap-x-6 gap-y-1">
            {tenantEmail ? (
              <p><span className="font-medium text-gray-700">Email:</span> {tenantEmail}</p>
            ) : null}
            {tenantPhone ? (
              <p><span className="font-medium text-gray-700">Phone:</span> {tenantPhone}</p>
            ) : null}
          </div>
        </div>

        {/* Body */}
        <div className="px-5 pb-5 pt-3 max-h-[60vh] overflow-auto">
          {loading ? (
            <div className="py-10 text-center text-sm text-gray-500">Loading…</div>
          ) : ratings?.length ? (
            <ul className="space-y-3">
              {ratings.map((r, i) => (
                <li
                  key={i}
                  className="rounded-lg border border-gray-200 p-3 sm:p-4 bg-white"
                >
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-2">
                      <span className="text-yellow-500">{'★'.repeat(r.rating || 0)}</span>
                      <span className="text-gray-400">{'★'.repeat(Math.max(0, 5 - (r.rating || 0)))}</span>
                    </div>
                    {r.date ? (
                      <span className="text-xs text-gray-500">{new Date(r.date).toLocaleDateString()}</span>
                    ) : null}
                  </div>
                  {r.comment ? (
                    <p className="mt-2 text-sm text-gray-700">{r.comment}</p>
                  ) : (
                    <p className="mt-2 text-sm text-gray-400 italic">No comment</p>
                  )}
                  {r.landlord ? (
                    <p className="mt-2 text-xs text-gray-500">by {r.landlord}</p>
                  ) : null}
                </li>
              ))}
            </ul>
          ) : (
            <div className="py-10 text-center text-sm text-gray-500">
              No previous ratings found for this tenant.
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="px-5 py-4 border-t flex justify-end">
          <button
            onClick={onClose}
            className="h-10 px-4 rounded-md border border-gray-300 text-[#09114B] text-sm font-medium hover:bg-gray-50"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default PreviousRatingsModal;
